import {ComposedValidationEntry, ValidationEntry, ValidationFunction} from "./Validator";
import {calculateAge, isBlank, isOnlyWhitespace} from "../util/ValidationUtil";
import {isPossiblePhoneNumber} from 'react-phone-number-input'
import {start} from "repl";


export class Validators{

    public static requireNotBlankValidator(keyOverride?:string):ValidationFunction<any>{
        return (key:string, attribute:string, obj:any) =>{
            return isBlank(attribute) || isOnlyWhitespace(attribute) ? {success:false, error:`${keyOverride ? keyOverride : key} cannot be blank.`} : {success:true, error:''};
        };
    }

    public static requireIsInt(keyOverride?:string):ValidationFunction<any>{
        return (key:string, attribute:any, obj:any) =>{
            return isNaN(parseInt(attribute)) ? {success:false, error:`${keyOverride ? keyOverride : key} must be an integer.`} : {success:true, error:''};
        };
    }

    public static requireRange(startingNum:number, endingNum:number, keyOverride?:string):ValidationFunction<any>{
        return (key:string, attribute:number, obj:any) =>{
            return attribute < startingNum || attribute > endingNum ? {success:false, error:`${keyOverride ? keyOverride : key} must be between ${startingNum} and ${endingNum}.`} : {success:true, error:''};
        };
    }

    public static requireBlankValidator(keyOverride?:string, passedSelect?:string):ValidationFunction<any>{
        return (key:string, attribute:string, obj:any) =>{
            return attribute ? {success:false, error:`${keyOverride ? keyOverride : key} cannot have value if ${passedSelect} is not Yes.`} : {success:true, error:''};
        };
    }

    public static requireNonNullValidator(keyOverride?:string):ValidationFunction<any>{
        return (key:string, attribute:any, obj:any) =>{
            return !attribute ? {success:false, error:`${keyOverride ? keyOverride : key} cannot be empty.`} : {success:true, error:''};
        };
    }

    public static requireNotFutureDate(keyOverride?:string):ValidationFunction<any>{
        return (key:string, attribute:Date, obj:any) =>{
            return new Date(attribute) > new Date() ? {success:false, error:`${keyOverride ? keyOverride : key} cannot be in the future.`} : {success:true, error:''};
        };
    }

    public static requireNotBeforeToday(keyOverride?:string):ValidationFunction<any>{
        return (key:string, attribute:Date, obj:any) =>{
            return new Date(attribute) < new Date() ? {success:false, error:`${keyOverride ? keyOverride : key} cannot be in the past.`} : {success:true, error:''};
        };
    }

    public static requireValidEmail(keyOverride?:string):ValidationFunction<any>{
        return (key:string, attribute:string, obj:any) =>{
            return !attribute || !/^[^\s@]+@[^\s@]+[.][^\s@]+$/.test(attribute) ? {success:false, error:`${keyOverride ? keyOverride : key} must be a valid email address.`} : {success:true, error:''};
        };
    }

    public static requireLength(maxLength:number, keyOverride?:string):ValidationFunction<any>{
        return (key:string, attribute:string, obj:any) =>{
            return attribute.length > maxLength ? {success:false, error:`${keyOverride ? keyOverride : key} cannot be longer than ${maxLength.toString()}.`} : {success:true, error:''};
        };
    }

    public static requirePhone(keyOverride?:string):ValidationFunction<any>{
        return (key:string, attribute:string, obj:any) =>{
            return !isPossiblePhoneNumber(attribute) ? {success:false, error:`${keyOverride ? keyOverride : key} is not a valid phone number.`} : {success:true, error:''};
        };
    }

    public static requireZip(keyOverride?:string):ValidationFunction<any>{
        return (key:string, attribute:string, obj:any) =>{
            return !/^\d{5}(-\d{4})?(?!-)$/.test(attribute) ? {success:false, error:`${keyOverride ? keyOverride : key} is not a valid zipcode.`} : {success:true, error:''};
        };
    }

    public static requireNotBlankIfExistsValidator(initialValue:any, keyOverride?:string):ValidationFunction<any>{
        return (key:string, attribute:any, obj:any) =>{
            return initialValue && !attribute ? {success:false, error:`${keyOverride ? keyOverride : key} can not be changed to blank.`} : {success:true, error:''};
        };
    }

    public static requireNotBeforePatientDOB(patientDOB:Date, keyOverride?:string):ValidationFunction<any>{
        return (key:string, attribute:Date, obj:any) =>{
            return new Date(attribute).getTime() < new Date(patientDOB).getTime() ? {success:false, error:`${keyOverride ? keyOverride : key} can not be before Patient DOB.`} : {success:true, error:''};
        };
    }

    public static requireDOBLessThan150Years(years:number, keyOverride?:string):ValidationFunction<any>{
        return (key:string, attribute:Date, obj:any) =>{
            return calculateAge(attribute) > years ? {success:false, error:`${keyOverride ? keyOverride : key} can not be more than ${years} years ago.`} : {success:true, error:''};
        };
    }

    public static requireNotBlankAndLength(maxLength:number, keyOverride?:string):ComposedValidationEntry<any>{
        return new ComposedValidationEntry<any>(
            new ValidationEntry(Validators.requireNotBlankValidator(keyOverride)), new ValidationEntry(Validators.requireLength(maxLength, keyOverride)))
    }

    public static requireDOB(years:number, keyOverride?:string):ComposedValidationEntry<any>{
        return new ComposedValidationEntry<any>(
            new ValidationEntry(Validators.requireNonNullValidator(keyOverride)), new ValidationEntry(Validators.requireNotFutureDate(keyOverride)), new ValidationEntry(Validators.requireDOBLessThan150Years(years, keyOverride)))
    }

    public static requireFactor(startingNum, endingNum, keyOverride?:string):ComposedValidationEntry<any>{
        return new ComposedValidationEntry<any>(
            new ValidationEntry(Validators.requireNonNullValidator(keyOverride)), new ValidationEntry(Validators.requireRange(startingNum, endingNum, keyOverride)), new ValidationEntry(Validators.requireIsInt(keyOverride)))
    }

}